import { render, staticRenderFns } from "./Recast.vue?vue&type=template&id=0c098217&"
import script from "./Recast.vue?vue&type=script&lang=js&"
export * from "./Recast.vue?vue&type=script&lang=js&"
import style0 from "./Recast.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Recast.vue"
export default component.exports